jQuery(function($){
	if($('.can-be-hidden').length) {
		const icons = ['eye', 'eye-closed'];

		let postId; 
		let firstCanBeHidden = $('.can-be-hidden').first();
		if(firstCanBeHidden.closest('.edit-form').length) {
			postId = firstCanBeHidden.closest('.edit-form').find('[name="post_id"]').val();
		} else if(firstCanBeHidden.closest('.details').length) {
			postId = firstCanBeHidden.closest('.details').attr('post_id');
		}

		$('.can-be-hidden').each(function(){
			const el = $(this);
			const field = el.attr('hidden_field');

			let toggle = '<div class="visibility-toggle" field="' + field + '" title="Hide from members">';
			$.each(icons, function(index, icon){
				toggle += '<img src="/wp-content/plugins/choralorg/assets/img/' + icon + '.png" class="' + icon + '">';
			});
			toggle += '</div>';
			el.append(toggle);

			//Run hidden field check on back end
			if(firstCanBeHidden.closest('.edit-form').length) {
				const data = {
					action: 'choralorg_ajax_get_member_hidden_field',
					post_id: postId,
				};

				$.post('/wp-admin/admin-ajax.php', data, function(response){
					console.log(response);
					if(response === false || response === 'false') return;
					const responseJson = JSON.parse(response);
					console.log(responseJson);
					if(responseJson.includes(field)) el.addClass('is-hidden');
				});
			}
		});

		$('.can-be-hidden').on('click', '.visibility-toggle', function(){
			const parentDiv = $(this).closest('.can-be-hidden');
			const field = $(this).attr('field');
			const wasHidden = parentDiv.hasClass('is-hidden');

			parentDiv.toggleClass('is-hidden');

			if(!parentDiv.find('.ajax-save').length) {
				parentDiv.append('<div class="ajax-save">Saving</div>');
			} else {
				parentDiv.find('.ajax-save').html('Saving').removeClass('saved');
			}

			const data = {
				action: 'choralorg_member_hidden_field_change',
				post_id: postId,
				field: field,
				hide: !wasHidden,
			};

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response);
				parentDiv.find('.ajax-save').html('Saved').addClass('saved');
			});
		});
	}

	$('.details #edit-hidden-fields-trigger').on('click', function(){
		$(this).closest('.details').toggleClass('edit-hidden-fields');
	});
});
